import { useEffect } from 'react'

import { Box } from '@chakra-ui/react'

import Loader from 'src/components/widgets/Loader'
import { useActivationCode } from 'src/lib/hooks/auth/useActivationCode'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

import ActivateItList from './ActivateItList/ActivateItList'

import { redirectToItList } from '.'

const UnlockItList: React.FC<{
  id: number
  email: string
  activationCode: string
}> = ({ id, email, activationCode }) => {
  const { sendActivationCode } = useActivationCode()
  const { email: currentUserEmail, isAuthenticated } = useCurrentUser()

  const login = async () => {
    const { error } = await sendActivationCode({ email, activationCode })
    if (error) {
      console.error(error)
      redirectToItList(id, `Oops, that link is invalid.`)
    }
  }

  useEffect(() => {
    if (isAuthenticated === false) {
      login()
    } else if (email !== currentUserEmail) {
      redirectToItList(id, 'Oops, that access link is for a different account.')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  return isAuthenticated && email === currentUserEmail ? (
    <ActivateItList itListId={id} />
  ) : (
    <Box>
      <Loader mt={10} />
      <Box color="graphite" textAlign="center">
        Logging you in...
      </Box>
    </Box>
  )
}

export default UnlockItList
